import { Typography } from "@bigbinary/neeto-atoms";
import classnames from "classnames";
import { isNotPresent } from "neetocist";
import PropTypes from "prop-types";

const CardLayout = ({
  className = "",
  icon,
  containerClassName = "",
  title = null,
  description = null,
  actionBlock,
  children,
}) => (
  <div
    data-testid="neeto-molecules-card-container"
    className={classnames([
      "nv-card-container mx-auto w-full max-w-3xl",
      containerClassName,
    ])}
  >
    <div
      data-testid="neeto-molecules-card"
      className={classnames([
        "nv-card border-border my-6 w-full rounded-lg border",
        className,
      ])}
    >
      <div className="nv-card-content p-4 md:p-6">
        {icon && (
          <div className="nv-card-icon-wrapper mb-4 w-full text-start">
            {icon}
          </div>
        )}
        {title && (
          <Typography
            variant="h2"
            className={classnames([
              "mb-2",
              { "pb-2": isNotPresent(description) },
            ])}
          >
            {title}
          </Typography>
        )}
        {description && (
          <Typography className="mb-4" variant="body1">
            {description}
          </Typography>
        )}
        {children}
      </div>
      {actionBlock && (
        <div
          className={classnames([
            "nv-card-action-block bg-muted sticky bottom-0 w-full rounded-lg rounded-t-none p-4 md:px-6",
            className,
          ])}
        >
          {actionBlock}
        </div>
      )}
    </div>
  </div>
);

CardLayout.propTypes = {
  /**
   * To set the title of the card.
   */
  title: PropTypes.string,
  /**
   * To set the description of the card.
   */
  description: PropTypes.node,
  /**
   * To set custom class name to the card.
   */
  className: PropTypes.string,
  /**
   * To set custom class name to the card container.
   */
  containerClassName: PropTypes.string,
  /**
   * To specify the content to be rendered in the card footer.
   */
  actionBlock: PropTypes.node,
  /**
   * To specify the components to be rendered inside the card.
   */
  children: PropTypes.node,
  /**
   * To set the icon of the card.
   */
  icon: PropTypes.node,
};

export default CardLayout;
